import { render, staticRenderFns } from "./ExpeditionPrinterDeviceTab.vue?vue&type=template&id=bcda8c86&scoped=true&"
import script from "./ExpeditionPrinterDeviceTab.vue?vue&type=script&lang=js&"
export * from "./ExpeditionPrinterDeviceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcda8c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcda8c86')) {
      api.createRecord('bcda8c86', component.options)
    } else {
      api.reload('bcda8c86', component.options)
    }
    module.hot.accept("./ExpeditionPrinterDeviceTab.vue?vue&type=template&id=bcda8c86&scoped=true&", function () {
      api.rerender('bcda8c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-configuration/components/ExpeditionPrinterDeviceTab.vue"
export default component.exports